export default __webpack_public_path__ + "static/amazon-9b236a0d2c6c3025749de80dd7bbc700.png";